import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

const validationSchema = (orderData) =>
  Yup.object().shape({
    address1: Yup.string().required("Please enter address"),
    address2: Yup.string().max(64, "Maximum length of 64"),
    city: Yup.string().required("Please enter city"),
    contact_email: Yup.string().test(
      "test-email",
      "Please enter a valid email address",
      (value) => isEmail(value || "")
    ),
    contact_name: Yup.string()
      .required("Please enter your full name")
      .matches(/\w+(\s+\w+)+/, {
        message: "Please enter your first and last name",
      }),
    contact_phone_num: Yup.string()
      .matches(/^[\d\-+(). ]{10,20}$/, {
        message: "Please enter a valid phone number",
      })
      .required("Please enter a valid phone number"),
    new_ring_size: Yup.string().required("Please choose a new ring size"),
    postal_code: Yup.string()
      .trim()
      .matches(new RegExp(orderData.shipping_info.postal_pattern), {
        message: `Please enter valid ${orderData.shipping_info.postal_label.toLowerCase()}`,
      })
      .required(
        `Please enter valid ${orderData.shipping_info.postal_label.toLowerCase()}`
      ),
    rma_id: Yup.string(),
    state: orderData.shipping_info.has_states
      ? Yup.string().required(
          `Please select a Shipping ${orderData.shipping_info.state_label}`
        )
      : null,
  })

export default validationSchema
